import React from "react";
import TextField from "@material-ui/core/TextField";
import Chip from "@material-ui/core/Chip";
import CloseIcon from "@material-ui/icons/Close";
import { Autocomplete } from "@material-ui/lab";

function PillAutocomplete(props) {
  const { options, onChange } = props;

  return (
    <Autocomplete
      multiple
      options={options}
      value={props.categories}
      onChange={(_, newValue) => {
        onChange(newValue);
      }}
      filterSelectedOptions
      getOptionLabel={(opt) => opt}
      renderTags={(selected, getTagProps) =>
        selected.map((option, index) => (
          <Chip
            key={option}
            label={option}
            // important: wire up deletion via getTagProps
            {...getTagProps({ index })}
            // make it look like a pill
            variant="default"
            size="small"
            style={{
              borderRadius: 16,
              margin: 2,
              fontWeight: 500,
            }}
            // custom cross icon
            deleteIcon={<CloseIcon style={{ fontSize: 16 }} />}
          />
        ))
      }
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label="Select Categories"
          placeholder={props.categories?.length ? "" : "Choose Categories"}
          fullWidth
          InputProps={{
            ...params.InputProps,
          }}
        />
      )}
      openOnFocus
      clearOnBlur={false}
      disableCloseOnSelect
    />
  );
}

export default PillAutocomplete;
